// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_login_terms_intro = /** @type {(inputs: {}) => string} */ () => {
	return `I have read the`
};

const de_widget_login_terms_intro = /** @type {(inputs: {}) => string} */ () => {
	return `Ich habe die`
};

const es_widget_login_terms_intro = /** @type {(inputs: {}) => string} */ () => {
	return `He leído los`
};

const fr_widget_login_terms_intro = /** @type {(inputs: {}) => string} */ () => {
	return `J'ai lu les`
};

const fi_widget_login_terms_intro = /** @type {(inputs: {}) => string} */ () => {
	return `Olen lukenut`
};

const hi_widget_login_terms_intro = /** @type {(inputs: {}) => string} */ () => {
	return `मैंने पढ़ा है`
};

const ja_widget_login_terms_intro = /** @type {(inputs: {}) => string} */ () => {
	return `私は`
};

const nl_widget_login_terms_intro = /** @type {(inputs: {}) => string} */ () => {
	return `Ik heb de`
};

const pt_widget_login_terms_intro = /** @type {(inputs: {}) => string} */ () => {
	return `Li os`
};

const ro_widget_login_terms_intro = /** @type {(inputs: {}) => string} */ () => {
	return `Am citit`
};

const th_widget_login_terms_intro = /** @type {(inputs: {}) => string} */ () => {
	return `ฉันได้อ่าน`
};

const ur_widget_login_terms_intro = /** @type {(inputs: {}) => string} */ () => {
	return `میں نے پڑھا ہے`
};

const zh_hant1_widget_login_terms_intro = /** @type {(inputs: {}) => string} */ () => {
	return `我已閱讀`
};

const da_widget_login_terms_intro = /** @type {(inputs: {}) => string} */ () => {
	return `Jeg har læst`
};

const it_widget_login_terms_intro = /** @type {(inputs: {}) => string} */ () => {
	return `Ho letto i`
};

const vn_widget_login_terms_intro = /** @type {(inputs: {}) => string} */ () => {
	return `Tôi đã đọc`
};

const ko_widget_login_terms_intro = /** @type {(inputs: {}) => string} */ () => {
	return `저는`
};

const tr_widget_login_terms_intro = /** @type {(inputs: {}) => string} */ () => {
	return `Okudum:`
};

const lv_widget_login_terms_intro = /** @type {(inputs: {}) => string} */ () => {
	return `Es esmu izlasījis`
};

const ar_widget_login_terms_intro = /** @type {(inputs: {}) => string} */ () => {
	return `لقد قرأت`
};

const bs_widget_login_terms_intro = /** @type {(inputs: {}) => string} */ () => {
	return `Pročitao sam`
};

const sl_widget_login_terms_intro = /** @type {(inputs: {}) => string} */ () => {
	return `Prebral sem`
};

const id_widget_login_terms_intro = /** @type {(inputs: {}) => string} */ () => {
	return `Saya telah membaca`
};

const sv_widget_login_terms_intro = /** @type {(inputs: {}) => string} */ () => {
	return `Jag har läst`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_login_terms_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_login_terms_intro(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_login_terms_intro", locale)
	if (locale === "en") return en_widget_login_terms_intro(inputs)
	if (locale === "de") return de_widget_login_terms_intro(inputs)
	if (locale === "es") return es_widget_login_terms_intro(inputs)
	if (locale === "fr") return fr_widget_login_terms_intro(inputs)
	if (locale === "fi") return fi_widget_login_terms_intro(inputs)
	if (locale === "hi") return hi_widget_login_terms_intro(inputs)
	if (locale === "ja") return ja_widget_login_terms_intro(inputs)
	if (locale === "nl") return nl_widget_login_terms_intro(inputs)
	if (locale === "pt") return pt_widget_login_terms_intro(inputs)
	if (locale === "ro") return ro_widget_login_terms_intro(inputs)
	if (locale === "th") return th_widget_login_terms_intro(inputs)
	if (locale === "ur") return ur_widget_login_terms_intro(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_login_terms_intro(inputs)
	if (locale === "da") return da_widget_login_terms_intro(inputs)
	if (locale === "it") return it_widget_login_terms_intro(inputs)
	if (locale === "vn") return vn_widget_login_terms_intro(inputs)
	if (locale === "ko") return ko_widget_login_terms_intro(inputs)
	if (locale === "tr") return tr_widget_login_terms_intro(inputs)
	if (locale === "lv") return lv_widget_login_terms_intro(inputs)
	if (locale === "ar") return ar_widget_login_terms_intro(inputs)
	if (locale === "bs") return bs_widget_login_terms_intro(inputs)
	if (locale === "sl") return sl_widget_login_terms_intro(inputs)
	if (locale === "id") return id_widget_login_terms_intro(inputs)
	if (locale === "sv") return sv_widget_login_terms_intro(inputs)
	return "widget_login_terms_intro"
};